import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a86c0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Warehouses" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Склады" }),
      _createVNode(_component_router_link, { to: "/warehouses/create" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить склад ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "flex flex-col px-6 py-4 border bg-white mt-6",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchCity && _ctx.searchCity(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_input, {
          placeholder: "Наименование",
          value: _ctx.filters_state.title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.title) = $event)),
          class: "w-full"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Город",
          loading: _ctx.data_state.is_loading,
          failed: _ctx.data_state.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          options: _ctx.data_state.list,
          value: _ctx.filters_state.cityIds,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.cityIds) = $event)),
          multiselect: "",
          onRefresh: _ctx.loadCities
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          class: "second text small mr-3",
          loading: _ctx.state.is_loading,
          onClick: _ctx.resetFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small w-fit",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка городов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadWarehouses(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.WarehousesColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadWarehouses,
                onChangeLimit: _ctx.onLimitChange
              }, {
                buttons: _withCtx(() => [
                  _createVNode(_component_the_button, {
                    class: "primary text small mr-3",
                    onClick: _ctx.exportExcel,
                    loading: _ctx.excel_state.is_loading,
                    hint: "Скачать Excel"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ]),
                td: _withCtx(({ row, column }) => [
                  (column.key === 'id' && row.id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "text-blue-500",
                        to: `/warehouses/${row.id}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}